// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"CampaignInduction_componentStyle__TrAxY","drawButton":"CampaignInduction_drawButton__i1YqP"};